import { useIsDowngradedPerformanceDismissed } from "#/store/app/alerts/isDowngradedPerformanceDismissed";
import { useStalePortfolios } from "#/store/wallet/account/stalePortfolios";

export const useDowngradedPerformanceController = () => {
  const {
    isDowngradedPerformanceDismissed,
    setIsDowngradedPerformanceDismissed,
  } = useIsDowngradedPerformanceDismissed();

  const { shouldFetchAccountState } = useStalePortfolios();

  const isInvisible =
    isDowngradedPerformanceDismissed || !shouldFetchAccountState;

  const dismiss = () => {
    setIsDowngradedPerformanceDismissed(true);
  };

  return { isInvisible, dismiss };
};
